module.exports = __webpack_public_path__ + "static/media/16.f09319e2.JPG";